import { withRtlSupport } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import ChevronIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/chevron-right';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import reactReplacePlaceholder from 'react-replace-placeholder';

import type { StringTranslations } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

import STYLES from './PriceButton.module.scss';

const ChevronArrow = withRtlSupport(ChevronIcon);

type PriceButtonProps = {
  strings: StringTranslations;
  price: string;
};

const PriceButton = ({ price, strings }: PriceButtonProps) => {
  const buttonText = reactReplacePlaceholder(
    strings.component_deals_evolved_cta,
    {
      price,
    },
    '{',
    '}',
  ).join('');
  return (
    <div className={STYLES.PriceButton__button}>
      <BpkText textStyle={TEXT_STYLES.label1}>{buttonText}</BpkText>
      <div className={STYLES.PriceButton__buttonArrow}>
        <ChevronArrow />
      </div>
    </div>
  );
};

export default PriceButton;
